import { render } from "./gallery.vue?vue&type=template&id=a2cf8354&scoped=true"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=a2cf8354&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2cf8354"],['__file',"src/js/components/gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2cf8354"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2cf8354', __exports__)) {
    api.reload('a2cf8354', __exports__)
  }
  
  module.hot.accept("./gallery.vue?vue&type=template&id=a2cf8354&scoped=true", () => {
    api.rerender('a2cf8354', render)
  })

}


export default __exports__